import { Component, Input, OnInit } from '@angular/core';
import { User } from 'src/app/models/user/user.model';

@Component({
  selector: 'app-user-relationships',
  templateUrl: './user-relationships.component.html',
  styleUrls: ['./user-relationships.component.scss'],
})
export class UserRelationshipsComponent implements OnInit {
  @Input() users?: User[];
  @Input() label?: string;

  ngOnInit(): void {
    (this.users ?? []).sort((a: User, b: User) =>
      a.getFullName().toUpperCase().localeCompare(b.getFullName().toUpperCase())
    );
  }
}
